import React, { useState, useEffect } from 'react'
import PrintScheduleBtn from '../Manager/Components/PrintScheduleBtn'
import ModeDropDown from '../Manager/Components/ModeDropDown/ModeDropDown'
import Search from '../Manager/Components/Search/Search'
import { SearchResultsProvider } from '../../utils/Contexts/SearchResultsContext'
import SearchResults from '../Manager/Components/Search/SearchResults'
import { SelectedDateProvider } from '../../utils/Contexts/SelectedDateContext'

const NavBar = ({ status, docks, userRole, usercode, location, selectedDock, managerMode, setManagerMode, widescreenMode, onOpenSettings, suggestSettings }) => {
    let humanReadableToday = new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })
    let address = null
    if (docks) {
        if (docks[0].name === "All Docks") {
            address = docks[1]
        } else {
            address = docks[0]
        }
    }

    const containerClass = `d-flex justify-content-center align-items-stretch ${widescreenMode ? 'container-fluid' : 'container'}`

    const [statusDisplay, setStatusDisplay] = useState(null)

    useEffect(() => {
        if (!status) return

        let text = ''
        let spinner = false
        let autoHide = true
        let color = null

        if (status.includes('saving')) {
            text = 'Saving...'
            spinner = true
            autoHide = false
        } else if (status.includes('refreshing')) {
            text = 'Refreshing...'
            spinner = true
            autoHide = false
        } else if (status.includes('saved')) {
            text = 'Saved!'
            color = '#198754'
        } else if (status.includes('error')) {
            text = 'Error saving — please try again.'
            autoHide = false
            color = '#dc3545'
        } else if (status.includes('updating')) {
            text = 'Updating!'
        } else if (status.includes('clear')) {
            setStatusDisplay(null)
            return
        }

        if (!text) return

        setStatusDisplay({ text, spinner, color: color || null })

        if (autoHide) {
            const timer = setTimeout(() => setStatusDisplay(null), 3000)
            return () => clearTimeout(timer)
        }
    }, [status])

    return (
        <SelectedDateProvider>
            <SearchResultsProvider>

                <div className={containerClass}>

                    <div className="col-3 d-flex flex-row justify-content-center align-items-center" style={{ minWidth: 0 }}>
                        {address ? (
                            <div style={{ width: '100%', overflow: 'hidden' }}>
                                <div data-info="dockLocationName" className="xlargeFontSize" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {statusDisplay ? (
                                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: statusDisplay.color || 'inherit' }}>
                                            {statusDisplay.spinner && (
                                                <span
                                                    className="spinner-border spinner-border-sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            )}
                                            {statusDisplay.text}
                                        </span>
                                    ) : (
                                        address.dockLocationName
                                    )}
                                </div>
                                {userRole === 'readonly' && !statusDisplay && (
                                    <small>Read only mode
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-lock-fill ml-3" viewBox="0 0 16 16">
                                            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
                                        </svg>
                                    </small>
                                )}
                                <div><PrintScheduleBtn usercode={usercode} location={location} selectedDock={selectedDock} humanReadableToday={humanReadableToday} /></div>
                            </div>
                        ) : null}

                    </div>

                    <div className="col-6">
                        {address ?
                            <div style={{ marginTop: '1rem' }}>
                                <img src={"https://www2.shippersedge.com//images/logos/" + address.logo} alt={address.customerName + " logo"} height="60" />
                                <h5> Dock Scheduler</h5>
                            </div>
                            : null}

                    </div>
                    <div className="col-3 mt-1 pr-2">
                    {
                        address ?
                        <>
                            <Search usercode={usercode} />
                            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '0.5rem', width: '100%' }}>
                                <div style={{ flex: 1 }}>
                                    <ModeDropDown managerMode={managerMode} setManagerMode={setManagerMode} />
                                </div>
                                {onOpenSettings ? (
                                    <button
                                        className={`btn btn-sm btn-outline-secondary mt-1${suggestSettings ? ' settings-suggest' : ''}`}
                                        onClick={onOpenSettings}
                                        title="Settings"
                                        style={{ flexShrink: 0, marginBottom: '1px' }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-gear" viewBox="0 0 16 16">
                                        <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
                                        <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
                                        </svg>
                                    </button>
                                ) : null}
                            </div>
                        </>:
                        null
                    }
                    </div>


                </div>

                <SearchResults />
            </SearchResultsProvider>
        </SelectedDateProvider>
    )
}

export default NavBar
